import { Injectable } from "@angular/core";
import { GameThumbnailTagsSortOrder, ObgConfigFeAdaptiveClientGaming } from "@obg/gaming.config";
import { ConfigService } from "@obg/ngx.global";

import { GameThumbnailOptions } from "./game-thumbnail.model";

@Injectable({
	providedIn: "root",
})
export class GameThumbnailConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientGaming>) {}

	getMaxTagsCount(): number {
		return this.configService.get((x) => x.gamingUi.gameThumbnail.maxTagsCount, 1);
	}

	getShowJackpot(): boolean {
		return this.configService.get((x) => x.gamingUi.gameThumbnail.showJackpot, true);
	}

	// todo: Config vNext, update from Dictionary to an array - OBGB-11551
	getTagsSortOrder(): GameThumbnailTagsSortOrder {
		return this.configService.get((x) => x.gamingUi.gameThumbnail.tagsSortOrder, {
			new: 1,
			hot: 2,
		});
	}

	getCanOpenGameLauncher(): boolean {
		return this.configService.get((x) => x.gamingUi.gameThumbnail.canOpenGameLauncher, true);
	}

	getShowOpenClosed(): boolean {
		return this.configService.get((x) => x.gamingUi.gameThumbnail.showOpenClosed, true);
	}

	getShowBetLimits(): boolean {
		return this.configService.get((x) => x.gamingUi.gameThumbnail.showBetLimits, true);
	}

	getShowBetBehind(): boolean {
		return this.configService.get((x) => x.gamingUi.gameThumbnail.showBetBehind, true);
	}

	getShowAvailableSeats(): boolean {
		return this.configService.get((x) => x.gamingUi.gameThumbnail.showAvailableSeats, true);
	}

	getShowRouletteResults(): boolean {
		return this.configService.get((x) => x.gamingUi.gameThumbnail.showRouletteResults, true);
	}

	getShowThumbnailOverlay(): boolean {
		return this.configService.get((x) => x.gamingUi.gameThumbnail.showThumbnailOverlay, true);
	}

	getGameThumbnailOptions(): GameThumbnailOptions {
		return {
			showJackpot: this.getShowJackpot(),
			maxTagsCount: this.getMaxTagsCount(),
			canOpenGameLauncher: this.getCanOpenGameLauncher(),
			showOpenClosed: this.getShowOpenClosed(),
			showBetLimits: this.getShowBetLimits(),
			showBetBehind: this.getShowBetBehind(),
			showAvailableSeats: this.getShowAvailableSeats(),
			showRouletteResults: this.getShowRouletteResults(),
			showThumbnailOverlay: this.getShowThumbnailOverlay(),
		};
	}
}
